import { SimulationSummaryDownloadClientRequest } from '../../../@types/SimulationSummaryDownload'
import { Report } from '../../../Components/SimulationReport/Identification'
import { ENV } from '../../../Environment'
import { useAnimalStore } from '../../../Stores/animalStore'
import { useReportStore } from '../../../Stores/reportStore'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { useEntityDetailsForSummaryDocumentStore } from '../../../Stores/useEntityDetailsForSummaryDocumentStore'
import { useFillDataForSimulationStore } from '../../../Stores/useFillDataForSimulationStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { ID_EXTERNAL_TYPES } from '../../../constants/idExternalTypes'

export const useSimulationSummaryDownloadPayload = () => {
  const { fillDataForSimulationRequest } = useFillDataForSimulationStore()
  const { entitySelected, entitySelectedAddress, typeOfPrice } =
    useSimulatorStore()
  const { entityDetailsForSummaryDocumentSelected } =
    useEntityDetailsForSummaryDocumentStore()
  const { runPetisSimulation, selectedPackCampaign } =
    useRunPetisSimulationStore()
  const { isProspect } = useReportStore()
  const { animalsList } = useAnimalStore()

    const isPartner = entitySelected === null || entityDetailsForSummaryDocumentSelected?.isProspect || isProspect
    ? ID_EXTERNAL_TYPES.isPartner
    : ID_EXTERNAL_TYPES.globalEntity

  const handleSimulationSummaryDownloadPayload = (
    report: Partial<Report>,
    hasChangedValue: boolean,
  ) => {
    const firstAnimal = animalsList?.[0]

    const payload: SimulationSummaryDownloadClientRequest = {
      agentExternalID:
        fillDataForSimulationRequest?.agentDetailsResponse?.agentCode || '',
      idExternalType: isPartner || '',
      newContactInformation: hasChangedValue,
      agentEntityId:
        fillDataForSimulationRequest?.agentDetailsResponse?.agentEntityId || '',
      applicationCode: ENV().ApplicationCode,
      branchCode: ENV().SimulationSummaryDownload.BranchCodeSimulationSummary,
      preferredAddressId: entitySelectedAddress?.sequence || null,
      packId: firstAnimal.pack?.packId || '',
      installmentPlanCode: typeOfPrice || firstAnimal.pack?.installment || '',
      campaignId: (selectedPackCampaign?.coverages || [])?.length
        ? selectedPackCampaign?.campaignId
        : '',
      companyCode: ENV().SimulationSummaryDownload.CompanyCodeSimulationSummary,
      coreSystem: '', // TODO: Não tenho esse valor
      entityId: entityDetailsForSummaryDocumentSelected?.idEntity || '',
      lineOfBusinessCode:
        runPetisSimulation?.runPetisSimulationResponse?.productData
          ?.lineofBusiness?.lineofBusinessID || '',
      productCode:
        runPetisSimulation?.runPetisSimulationResponse?.productData
          ?.productCode || '',
      preferedEmailContact: report.email || '',
      preferedPhoneContact: report.phone || '',
      productFamilyId:
        runPetisSimulation?.runPetisSimulationResponse?.productData
          ?.lineofBusiness?.productFamilyID || '',
      productTypeId:
        runPetisSimulation?.runPetisSimulationResponse?.productData
          ?.lineofBusiness?.productTypeID || '',
      selectedPacks: report.packs || [],
      quoteId: runPetisSimulation?.runPetisSimulationResponse?.quoteId,
      vatNumber:
        entityDetailsForSummaryDocumentSelected?.vatNumber ||
        report.vatNumber ||
        '',
      fullName:
        entityDetailsForSummaryDocumentSelected?.name || report.name || '',
      entityType:
        entitySelected?.entityType ||
        entityDetailsForSummaryDocumentSelected?.entityType ||
        'P', // TODO: Hardcoded, não tenho o valor
      originTemplate: 'PTL', // TODO: Hardcoded
      segmentCode:
        runPetisSimulation?.runPetisSimulationResponse?.productData?.segment
          ?.segmentCode || '',
    }

    return payload
  }

  return {
    simulationSummaryDownloadPayload: (
      report: Partial<Report>,
      hasChangedValue: boolean,
    ) => handleSimulationSummaryDownloadPayload(report, hasChangedValue),
  }
}
